import { Controller } from "@hotwired/stimulus"

// The review screen's Next link, greyed out until the next question has rendered.
//
// A frame navigation shows nothing by itself: Turbo's progress bar is for page visits,
// and the `busy` attribute it sets on the frame is cleared as soon as the response
// headers arrive, before the body has loaded and rendered. A `turbo-frame[busy]` style
// would turn the link blue again while a learner on a slow connection is still waiting.
//
// So aria-busy goes on when this link's own request starts (not on click: a ctrl-click
// opens a tab and starts nothing here) and normally never comes off, because the frame
// render replaces the link. Only a failed request has to give it back.
export default class extends Controller {
  // A Turbo snapshot taken mid-request (the learner left the page) keeps the attribute.
  connect() {
    this.element.removeAttribute("aria-busy")
  }

  requestStarted(event) {
    if (event.target !== this.frame) return
    if (event.detail.url.pathname !== new URL(this.element.href).pathname) return

    this.element.setAttribute("aria-busy", "true")
  }

  requestFailed(event) {
    if (event.target === this.frame) this.element.removeAttribute("aria-busy")
  }

  // Another click would abort the request and start the wait over. Turbo ignores a click
  // whose default is prevented, and this runs first: the link is inside the frame.
  guardClick(event) {
    if (this.element.getAttribute("aria-busy") === "true") event.preventDefault()
  }

  get frame() {
    return this.element.closest("turbo-frame")
  }
}
